import {gql} from '@apollo/client';
import {pwaClient} from './graphql_clients';
import {FailureIndicatorsQuery} from '../gql/pwa/graphql';
import {pwaRequestHeaders} from '../support/network.ts';

const FAILURE_INDICATORS = gql`
    query failureIndicators($brand: String) {
        failureIndicators(brand: $brand) {
            id
            brand
            image_url
            description
            __typename
        }
    }
`;

export class FailureIndicators {
    static async getIndicators(brand: string | null) {
        return await pwaClient.query<FailureIndicatorsQuery>({
            query: FAILURE_INDICATORS,
            variables: {
                brand: brand,
            },
            context: {
                headers: pwaRequestHeaders,
            },
        });
    }
}
